import type { SVGProps } from "react";

export default function DocumentIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      id="Layer_2"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18.78 23.18"
      width={20}
      height={20}
      fill="currentColor"
      {...props}
    >
      <g id="Layer_1-2" data-name="Layer 1-2">
        <path d="M17.33,0h-9.01c0,.07.02.15.02.22v5.79c0,1.31-1.06,2.38-2.37,2.38H.22c-.07,0-.15,0-.22-.02v13.35c0,.8.65,1.46,1.45,1.46h15.88c.8,0,1.45-.66,1.45-1.46V1.46c0-.8-.65-1.46-1.45-1.46ZM.22,6.57h5.75c.3,0,.55-.25.55-.55V.22c0-.09-.07-.15-.15-.15-.04,0-.07,0-.1.04L.12,6.33c-.09.1-.03.25.1.25H.22Z" />
      </g>
    </svg>
  );
}
